import { reactive } from "@vue/composition-api";
import axios from "axios";
import router from "@/router";

export default function companyStore() {
  type state = {};
  const state = reactive({
    loading: false,
    isFavorite: false,
    addressPostal: {} as any,
    decrypt: {} as any,
    companyError: {
      status: 200 as any
    } as any,
    registCardText: {
      textBtnRegistCard: "",
      textRegisted: "",
    },
    menu: {
      mini: true,
      drawer: true,
      windowWidth: 0,
      windowHeight: 0,
      companyCode: ''
    },
    companyInformation: {
      companyInforList: {
        company_id: '',
        company_name: "",
        company_name_furigana: "",
        representative_name: "",
        representative_name_furigana: "",
        representative_position: "",
        branch_name: "",
        industry_code: "",
        company_user_name: "",
        person_in_charge_position: "",
        company_user_name_furigana: "",
        postal_code: "",
        postal_code_0: "",
        postal_code_1: "",
        address: "",
        address_1: "",
        address_2: "",
        department_name: "",
        telephone_number: "" as any,
        telephone_number_1: "",
        telephone_number_2: "",
        telephone_number_3: "",
        company_mail: "" as any,
        password: "",
        approval_flag: '',
        cyurika_deposit_flg: '',
        tax_deduct: 0,
        prefecture_code: 0,
        city_code: 0,
        ht_flg: 0
      } as any,
      industryListCode: [],
      evaluationInforList: [] as any,
      compareTelephoneNumber: "",
      switchMe: true,
      dialog: false,
      evaluationAverage: 0,
      evaluationNumber: 0,
      titleCompanyInfor: '企業情報',
      titleCompanyCreate: '新規登録',
      titleEvaluation: '総合評価',
      titleEvaluationList: '評価一覧',
      titleFavoriteUser: 'お気に入りユーザー 一覧',
      titleDialog: '評価詳細',
    },
    tableEvaluationList: {
      titleEvaluationList: '評価一覧',
      headersEvaluation: [
        { text: "求人名", value: "business_name", align: 'center' },
        { text: "ユーザー名", value: "cyurica_num", align: 'center', sortable: false },
        { text: "評価", value: "evaluation_code", align: 'center', sortable: false },
        { text: "コメント", value: "comment", align: 'center', sortable: false },
        { text: "詳細", value: "detail", align: 'center', sortable: false },
      ],
      values: [],
      dialog: {
        jobName: "",
        userName: "",
        evaluation: "",
        comment: "",
        titleDialog: '評価詳細',
      },
    },
    tableFavoriteUser: {
      titleFavoriteUser: 'お気に入りユーザー 一覧',
      headersListUser: [
        { text: "ユーザー名", value: "cyurica_num", align: 'center' },
        { text: "求人名", value: "business_name", align: 'center', sortable: false },
        { text: "評価", value: "evaluation_code", align: 'center', sortable: false },
        { text: "詳細", value: "detail", align: 'center', sortable: false },
      ],
      values: []
    },
    registerCardInformation: {
      menu: false,
      cardNumber: '',
      expiresDate: '',
      expiresMonth: '',
      expiresYear: '',
      cardName: '',
      titleRegisterCard: 'カード情報変更',
      token_key: '' as any,
      getTokenStatus: '' as any,
      registerCardError: '',
      radioGroup: 1,
      zeus_token_error_messages: {
        "88888888": "繝｡繝ｳ繝�リ繝ｳ繧ｹ荳ｭ縺ｧ縺吶�",
        "90100100": "騾壻ｿ｡縺ｫ螟ｱ謨励＠縺ｾ縺励◆縲�",
        "99999999": "縺昴�莉悶�繧ｷ繧ｹ繝�Β繧ｨ繝ｩ繝ｼ縺檎匱逕溘＠縺ｾ縺励◆縲�",
        "02030105": "METHOD が 'POST' 以外",
        "02030106": "CONTENT-TYPE が 'text/xml' もしくは 'application/xml' 以外",
        "02030107": "CONTENT-LENGTH が存在しないか、０が指定されている",
        "02030108": "CONTENT-LENGTH が 8192 byte より大きい",
        "02030207": "XML データが未送信",
        "02030208": "XML データが 8192 byte より大きい",
        "02030209": "XML データに構文エラーがある",
        "02080114": "XML の action が空",
        "02080115": "無効な action が指定されている",
        "02130114": "XML に authentication clientip が存在しない",
        "02130117": "clientip のフォーマットが不正",
        "02130110": "不正な clientip が指定された",
        "02130118": "不正な clientip が指定された",
        "02130514": "「カード番号」を入力してください",
        "02130517": "「カード番号」を正しく入力してください",
        "02130619": "「カード番号」を正しく入力してください",
        "02130620": "「カード番号」を正しく入力してください",
        "02130621": "「カード番号」を正しく入力してください",
        "02130640": "「カード番号」を正しく入力してください",
        "02130714": "「有効期限(年)」を入力したください",
        "02130717": "「有効期限(年)」を正しく入力したください",
        "02130725": "「有効期限(年)」を正しく入力したください",
        "02130814": "「有効期限(月)」を入力したください",
        "02130817": "「有効期限(月)」を正しく入力したください",
        "02130825": "「有効期限(月)」を正しく入力したください",
        "02130922": "「有効期限」を正しく入力したください",
        "02131014": "CVVが不正です",
        "02131017": "「セキュリティコード」を正しく入力してください",
        "02131117": "「カード名義」を正しく入力してください",
        "02131123": "「カード名義」を正しく入力してください",
        "02131124": "「カード名義」を正しく入力してください",
      } as any
    },
    userDetailInformation: {
      userInforList: {
        address1: '',
        address2: '',
        dateOfBirth: '',
        gender: '',
        mailAddress: '',
        name: '',
        nameKana: '',
        phone: '',
        zipcode: '',
        card_number: ''
      },
      attendanceReason: '',
      applicationStatus: '',
      work_start: '',
      userRatingInfor: [] as any,
      userChatInfor: [] as any,
      skill: [] as any,
      menu: false,
      menuBirthDay: false,
      evaluation: 0,
      evaluationTotal: 0,
      evaluationAverage: 0,
      totalComment: 0,
      titleUserDetail: 'ユーザー詳細',
      titleEvaluation: '総合評価',
      titleChat: 'チャット',
      titleRating: '全企業から出したユーザー評価',
      titleUserRating: '全企業から出したユーザー評価'
    }
  });
  const axiosinstance = axios.create({
    baseURL: process.env.VUE_APP_API_SERVER
  });
  axiosinstance.defaults.timeout = 60000000;
  axiosinstance.interceptors.response.use(
    // 2XX範囲内のステータスコード
    (response) => {
      return response;
    },
    // 2XX範囲外のステータスコード
    (error) => {
      var response = error.response
      const isTimeOut = error.code === "ECONNABORTED";
      if (isTimeOut) {
        state.loading = false;
        router.push("/timeout-error");
        return error;
      }
      if (!error.response) {
        state.loading = false;
        router.push("/network-error");
        return error;
      }else if(response && (response.status == 401 || response.status == 500)){
        localStorage.clear()
        router.push("/");
      } else {
        state.loading = false;
        state.companyError = error.response;
      }
    }
  );

  return {
    get companyError() {
      return state.companyError
    },
    get loading() {
      return state.loading
    },
    get menu() {
      return state.menu
    },
    get companyInformation() {
      return state.companyInformation
    },
    get tableEvaluationList() {
      return state.tableEvaluationList
    },
    get tableFavoriteUser() {
      return state.tableFavoriteUser
    },
    get registerCardInformation() {
      return state.registerCardInformation
    },
    get userDetailInformation() {
      return state.userDetailInformation
    },
    get registCardText() {
      return state.registCardText
    },

    get isFavorite(){
      return state.isFavorite
    },
    setIsFavorite(value:boolean){
      state.isFavorite = value
    },

    inputRegistDate(e: string) {
      state.registerCardInformation.expiresDate = e
    },

    getWindowWidth() {
      state.menu.windowWidth = document.documentElement.clientWidth;
    },
    getWindowHeight() {
      state.menu.windowHeight = document.documentElement.clientHeight;
    },

    clearCompanyName() {
      if (state.companyInformation.companyInforList.company_user_name === '') {
        state.companyInformation.companyInforList.company_user_name_furigana = ''
      }
    },

    clearRegistCardInfor() {
      state.registerCardInformation.expiresDate = ''
      state.registerCardInformation.cardName = ''
      state.registerCardInformation.cardNumber = ''
    },

    registerCardInfor() {
      const left = (screen.width / 2) - (500);
      const top = (screen.height / 2) - (300);
      return window.open('/company_detail/info', '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=1000px, height=600px, top=' + top + ', left=' + left);
    },

    closeWindow() {
      window.close()
    },

    getIndustryCode() {
      return axiosinstance
        .get(
          "admin/v0/mstCode?code_type=002",
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.companyInformation.industryListCode = response.data
        })
        .then(() => {
          return true
        })
    },

    async getCompanyInfor() {
      await axiosinstance
        .get(
          "company/v0/company",
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.companyInformation.companyInforList = response.data
          state.menu.companyCode = response.data.ht_company_code
          if (response.data.tax_deduct === 1) {
            state.companyInformation.switchMe = true
          } else {
            state.companyInformation.switchMe = false
          }
          state.companyInformation.compareTelephoneNumber = response.data.telephone_number.split('-').join('')
          response.data.company_mail = response.data.company_mail.split('@')
          response.data.telephone_number = response.data.telephone_number.split('-')
          state.companyInformation.industryListCode.map((item: any) => {
            if (item.code === response.data.industry_code) {
              state.companyInformation.companyInforList.industry_code = item.code_desc
            }
          })
          if (response.data.industry_code === "1") {
            state.companyInformation.companyInforList.industry_code = ''
          }
          if(response.data.card_info_flg === 1){
            state.registCardText.textBtnRegistCard = "カード情報変更"
            state.registCardText.textRegisted = "登録済み"
          } else {
            state.registCardText.textBtnRegistCard = "カード情報登録"
            state.registCardText.textRegisted = ""
          }
          state.companyInformation.companyInforList = response.data
        })
        .then(() => {
        });

    },

    clearCompanyInfor() {
      state.companyInformation.companyInforList.company_name = ""
      state.companyInformation.companyInforList.company_name_furigana = ""
      state.companyInformation.companyInforList.representative_name = ""
      state.companyInformation.companyInforList.representative_name_furigana = ""
      state.companyInformation.companyInforList.representative_position = ""
      state.companyInformation.companyInforList.branch_name = ""
      state.companyInformation.companyInforList.industry_code = ""
      state.companyInformation.companyInforList.company_user_name = ""
      state.companyInformation.companyInforList.person_in_charge_position = ""
      state.companyInformation.companyInforList.company_user_name_furigana = ""
      state.companyInformation.companyInforList.postal_code = ""
      state.companyInformation.companyInforList.address = ""
      state.companyInformation.companyInforList.address_1 = ""
      state.companyInformation.companyInforList.address_2 = ""
      state.companyInformation.companyInforList.department_name = ""
      state.companyInformation.companyInforList.telephone_number = ""
      state.companyInformation.companyInforList.company_mail = ""
      state.companyInformation.companyInforList.password = ""
      state.companyInformation.companyInforList.approval_flag = ''
      state.companyInformation.companyInforList.cyurika_deposit_flg = ''
      state.companyInformation.companyInforList.tax_deduct = 0
    },

    clearBtnCardText() {
      state.registCardText.textBtnRegistCard = ""
      state.registCardText.textRegisted = ""
    },

    async registCreditCard() {
      state.loading = true
      const card_expires_month = state.registerCardInformation.expiresDate.split('-')[1]
      const card_expires_year = state.registerCardInformation.expiresDate.split('-')[0]
      const params = `
      <?xml version="1.0" encoding="UTF-8"?>
      <request service="token" action="newcard">
        <authentication>
          <clientip>2014002817</clientip>
        </authentication>
        <card>
          <number>${state.registerCardInformation.cardNumber}</number>
          <expires>
            <year>${card_expires_year}</year>
            <month>${card_expires_month}</month>
          </expires>
        <name>${state.registerCardInformation.cardName}</name>
      </card>
      </request>`
      let token_key = '' as any
      await axiosinstance
        .post(
          "https://linkpt.cardservice.co.jp/cgi-bin/token/token.cgi",
          params,
          {
            headers: {
              'Content-Type': 'text-xml',
            }
          }
        )
        .then(response => {
          let parser, xmlDoc;
          parser = new DOMParser();
          xmlDoc = parser.parseFromString(response.data, "text/xml");
          state.registerCardInformation.getTokenStatus = xmlDoc.getElementsByTagName("status")[0].childNodes[0].nodeValue
          if (state.registerCardInformation.getTokenStatus === "success") {
            token_key = xmlDoc.getElementsByTagName("token_key")[0].childNodes[0].nodeValue;
            state.registerCardInformation.token_key = token_key
          } else {
            let errorCode = xmlDoc.getElementsByTagName("code")[0].childNodes[0].nodeValue as any
            state.registerCardInformation.registerCardError = state.registerCardInformation.zeus_token_error_messages[errorCode]
          }
        })
        .then(() => {
          state.loading = false
        });
      if (token_key) {
        state.loading = true
        const registParams = {
          token_key: state.registerCardInformation.token_key
        }
        return new Promise(resolve => {
          axiosinstance
            .post(
              "company/v0/registCreditCard",
              registParams,
              {
                headers: {
                  "content-type": "application/json",
                  "Authorization": localStorage.getItem("token")
                }
              }
            )
            .then(response => {
              return !response
                ? resolve(state.companyError)
                : resolve(
                );
            })
            .then(() => {
              if (state.companyError.status == '500') {
                state.registerCardInformation.registerCardError = state.companyError.data
              }
              state.loading = false
            })
        })
      }
    },

    updateCompanyInfor() {
      return new Promise(resolve => {
        state.loading = true
        let industry_code = '1'
        state.companyInformation.industryListCode.map((item: any) => {
          if (state.companyInformation.companyInforList.industry_code === item.code_desc) {
            industry_code = item.code
          }
        })
        if (state.companyInformation.switchMe === true) {
          state.companyInformation.companyInforList.tax_deduct = 1
        } else {
          state.companyInformation.companyInforList.tax_deduct = 0
        }
        const params = {
          company_id: state.companyInformation.companyInforList.company_id,
          company_name: state.companyInformation.companyInforList.company_name,
          company_name_furigana: state.companyInformation.companyInforList.company_name_furigana,
          branch_name: state.companyInformation.companyInforList.branch_name,
          industry_code: industry_code,
          password: state.companyInformation.companyInforList.password,
          representative_name: state.companyInformation.companyInforList.representative_name,
          representative_name_furigana: state.companyInformation.companyInforList.representative_name_furigana,
          representative_position: state.companyInformation.companyInforList.representative_position,
          person_in_charge_name: state.companyInformation.companyInforList.company_user_name,
          person_in_charge_furigana: state.companyInformation.companyInforList.company_user_name_furigana,
          person_in_charge_position: state.companyInformation.companyInforList.person_in_charge_position,
          postal_code: state.companyInformation.companyInforList.postal_code,
          address: state.companyInformation.companyInforList.address,
          address_1: state.companyInformation.companyInforList.address_1,
          address_2: state.companyInformation.companyInforList.address_2,
          department_name: state.companyInformation.companyInforList.department_name,
          telephone_number: state.companyInformation.companyInforList.telephone_number.join('-'),
          company_mail: state.companyInformation.companyInforList.company_mail.join('@'),
          prefecture_code: state.companyInformation.companyInforList.prefecture_code,
          city_code: state.companyInformation.companyInforList.city_code,
          approval_flag: state.companyInformation.companyInforList.approval_flag,
          cyurika_deposit_flg: state.companyInformation.companyInforList.cyurika_deposit_flg,
          company_user_name: state.companyInformation.companyInforList.company_user_name,
          company_user_name_furigana: state.companyInformation.companyInforList.company_user_name_furigana,
          tax_deduct: state.companyInformation.companyInforList.tax_deduct,
        }
        axiosinstance
          .put(
            "company/v0/company",
            params,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": localStorage.getItem("token")
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyError)
              : resolve(
                state.companyInformation.companyInforList = response.data
              );
          })
          .then(() => {
            state.loading = false
            state.companyInformation.companyInforList.company_mail = state.companyInformation.companyInforList.company_mail.split('@')
            state.companyInformation.companyInforList.telephone_number = state.companyInformation.companyInforList.telephone_number.split('-')
            state.companyInformation.industryListCode.map((item: any) => {
              if (item.code === state.companyInformation.companyInforList.industry_code) {
                state.companyInformation.companyInforList.industry_code = item.code_desc
              }
            })
          });
      })
    },

    changeCompareTelephone() {
      state.companyInformation.compareTelephoneNumber = state.companyInformation.companyInforList.telephone_number.join('')
    },

    getEvaluationInfor() {
      axiosinstance
        .get(
          "company/v0/rating",
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.tableEvaluationList.values = response.data
          state.companyInformation.evaluationNumber = state.tableEvaluationList.values.length
        })
        .then(() => {
          let evalutionNumber = 0
          state.tableEvaluationList.values.map((items: any) => {
            evalutionNumber += +items.evaluation_code
          })
          state.companyInformation.evaluationAverage = evalutionNumber / state.companyInformation.evaluationNumber
        });
    },

    getFavoriteUser() {
      axiosinstance
        .get(
          "company/v0/favorite",
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.tableFavoriteUser.values = response.data
        })
        .then(() => {
        });
    },
    getIsavoriteUser(customer_id: string = '') {
      var get_url = "company/v0/favorite"
      if (customer_id != ''){
        get_url += "?customer_id=" + customer_id
      }
      axiosinstance
        .get(
          get_url,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.tableFavoriteUser.values = response.data
          state.isFavorite = (state.tableFavoriteUser.values.length > 0)
        })
        .then(() => {
        });
    },

    unlikeUser(customerId: string, jobId:string) {
      state.loading = true
      const params = {
        customer_id: customerId,
        job_information_id: jobId
      }
      axiosinstance
        .delete(
          "company/v0/favorite",
          {
            data: params,
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token") || localStorage.getItem('token-company')
            }
          }
        )
        .then(response => {
          state.isFavorite = false;
        })
        .then(() => {
          state.loading = false
        });
    },

    likeUser(customerId: string, jobId:string) {
      state.loading = true
      const params = {
        customer_id: customerId,
        job_information_id: jobId,
      }
      axiosinstance
        .post(
          "company/v0/favorite",
          params,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.isFavorite = true;
        })
        .then(() => {
          state.loading = false
        });
    },

    getUserDetailInfor(jobId: any, customerId: any) {
      state.loading = true
      axiosinstance
        .get(
          `company/v0/customerDetailOfCyurica?job_information_id=${jobId}&customer_id=${customerId}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          if (response.data.gender == 1) {
            response.data.gender = '男性'
          } else {
            response.data.gender = '女性'
          }
          response.data.dateOfBirth = response.data.dateOfBirth ? response.data.dateOfBirth.replace(/(\d{4})(\d{2})(\d{2})/g, '$1/$2/$3') : ''
          state.userDetailInformation.userInforList = response.data
        })
        .then(() => {
          state.loading = false
        });
    },

    getUserSkill(jobId: any, customerId: any) {
      axiosinstance
        .get(
          `company/v0/customer?job_information_id=${jobId}&customer_id=${customerId}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.userDetailInformation.work_start = response.data.work_start_date + ' ' + response.data.start_time
          if (response.data.application_status_code === '004001') {
            state.userDetailInformation.applicationStatus = '応募'
          }else if (response.data.application_status_code === '004003') {
            state.userDetailInformation.applicationStatus = '不採用'
          } else if (response.data.application_status_code === '004002') {
            state.userDetailInformation.applicationStatus = '採用'
          } else if (response.data.application_status_code === '004004') {
            state.userDetailInformation.applicationStatus = 'キャンセル'
          } else if (response.data.application_status_code === '004006') {
            state.userDetailInformation.applicationStatus = '勤務完了'
          } else if (response.data.application_status_code === '004007') {
            state.userDetailInformation.applicationStatus = '欠勤'
          }
          if (response.data.small_name) {
            response.data.small_name.split(',').map((items: any) => {
              state.userDetailInformation.skill.push(items)
            })
          }
        })
        .then(() => {
        });
    },
    getUserDetailRating(customerId: any) {
      state.loading = true
      axiosinstance
        .get(
          "company/v0/customerRating?customer_id=" + customerId,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.userDetailInformation.userRatingInfor = response.data
        })
        .then(() => {
          state.userDetailInformation.evaluationTotal = state.userDetailInformation.userRatingInfor.length
          let evalutionNumber = 0
          state.userDetailInformation.userRatingInfor.map((items: any) => {
            evalutionNumber += +items.evaluation_code
          })
          state.userDetailInformation.userRatingInfor = state.userDetailInformation.userRatingInfor.filter((item: any) =>{
            return (item.comment != null && item.comment != '')
          })
          state.userDetailInformation.totalComment = state.userDetailInformation.userRatingInfor.length
          state.userDetailInformation.evaluationAverage = evalutionNumber / state.userDetailInformation.evaluationTotal
          state.loading = false
        });
    },
    getAttendanceReason(customerId: any, jobId: any){
      state.loading = true
      axiosinstance
        .get(
          `company/v0/attendance?customer_id=${customerId}&job_information_id=${jobId}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.userDetailInformation.attendanceReason = response.data.attendance_reason
        })
        .then(() => {
          state.loading = false
        });
    },

    getUserChatInfor(customerId: any, jobId: any) {
      state.loading = true
      axiosinstance
        .get(
          `company/v0/chat?customer_id=${customerId}&job_information_id=${jobId}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.userDetailInformation.userChatInfor = response.data
          state.userDetailInformation.userChatInfor.map((items: any) => {
            items.send_day = items.send_day.split('T')
          })
        })
        .then(() => {
          state.userDetailInformation.userChatInfor.map((items: any) => {
            items.send_day = items.send_day.join(' ')
          })
          state.loading = false
        });
    },
    sendChat(customerId: any, jobId: any, message:any) {
      state.loading = true
      const params = {
        customer_id: customerId,
        job_information_id: jobId,
        message: message,
      }
      axiosinstance
        .post(
          'company/v0/chat',
          params,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
        })
        .then(() => {
          this.getUserChatInfor(customerId, jobId)
          state.loading = false
        });
    },

    searchPostalCode(postal1: any, postal2: any) {
      return new Promise(resolve => {
        state.companyInformation.companyInforList.prefecture_code = 0
        state.companyInformation.companyInforList.city_code = 0
        state.companyInformation.companyInforList.address_1 = ''
        state.addressPostal = '';
        const zipCode = postal1 + postal2
        state.loading = true
        axiosinstance
          .get(
            "company/v0/getAddress?zipcode=" + zipCode,
            {
              headers: {
                "content-type": "application/json",
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyError)
              : resolve(
                state.addressPostal = response.data
              );
          })
          .then(() => {
            if (state.addressPostal !== '') {
              state.companyInformation.companyInforList.prefecture_code = state.addressPostal.prefecture_code
              state.companyInformation.companyInforList.city_code = state.addressPostal.city_code
              state.companyInformation.companyInforList.address_1 = state.addressPostal.state + state.addressPostal.city + state.addressPostal.town
            }
            state.loading = false
          })
      })
    },

    decryptMail(token: any) {
      return new Promise(resolve => {
        state.companyInformation.companyInforList.company_mail = ''
        state.decrypt = ''
        state.loading = true
        token = encodeURIComponent(token)
        axiosinstance
          .get(
            "company/v0/decryptMail?regist_token=" + token,
            {
              headers: {
                "content-type": "application/json",
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyError)
              : resolve(
                state.decrypt = response.data
              );
          })
          .then(() => {
            if (state.decrypt !== '') {
              state.companyInformation.companyInforList.company_mail = state.decrypt.mail
            }
            state.loading = false
          })
      })
    },

    createCompanyInfor() {
      return new Promise(resolve => {
        state.loading = true
        let industry_code = '1'
        state.companyInformation.industryListCode.map((item: any) => {
          if (state.companyInformation.companyInforList.industry_code === item.code_desc) {
            industry_code = item.code
          }
        })
        if (state.companyInformation.switchMe === true) {
          state.companyInformation.companyInforList.tax_deduct = 1
        } else {
          state.companyInformation.companyInforList.tax_deduct = 0
        }
        const params = {
          company_name: state.companyInformation.companyInforList.company_name,
          company_name_furigana: state.companyInformation.companyInforList.company_name_furigana,
          branch_name: state.companyInformation.companyInforList.branch_name,
          industry_code: state.companyInformation.companyInforList.industry_code,
          representative_name: state.companyInformation.companyInforList.representative_name,
          representative_name_furigana: state.companyInformation.companyInforList.representative_name_furigana,
          person_in_charge_name: state.companyInformation.companyInforList.company_user_name,
          person_in_charge_furigana: state.companyInformation.companyInforList.company_user_name_furigana,
          department_name: state.companyInformation.companyInforList.department_name,
          company_mail: state.companyInformation.companyInforList.company_mail,
          postal_code: state.companyInformation.companyInforList.postal_code_0 + '-' + state.companyInformation.companyInforList.postal_code_1,
          prefecture_code: state.companyInformation.companyInforList.prefecture_code,
          city_code: state.companyInformation.companyInforList.city_code,
          address_1: state.companyInformation.companyInforList.address_1,
          address_2: state.companyInformation.companyInforList.address_2,
          
          telephone_number: state.companyInformation.companyInforList.telephone_number_1 + '-' +
          state.companyInformation.companyInforList.telephone_number_2 + '-' +
          state.companyInformation.companyInforList.telephone_number_3
          
        }

        axiosinstance
          .post(
            "company/v0/company",
            params,
            {
              headers: {
                "content-type": "application/json",
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyError)
              : resolve(
                state.companyInformation.companyInforList = response.data
              );
          })
          .then(() => {
            state.loading = false
          });
      })
    },
    execApplication(customer_id: any, job_information_id: any, common_id: any, status_code: string){
      return new Promise(resolve => {
        state.loading = true;
        const params = {
          customer_id: customer_id,
          job_information_id: job_information_id,
          common_id: common_id,
          status_code: status_code,
        };
        axiosinstance
          .patch(
            "company/v0/applicationInfo",
            params,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": localStorage.getItem("token")
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyError)
              : resolve(

              );
          })
          .then(() => {
            state.loading = false;
          })
      })
    },
    refreshToken(){
      var refresh_token = localStorage.getItem("refresh")
      if (refresh_token === null || refresh_token === ''){
        localStorage.clear()
        router.push("/");
      }
      const parames = {
        "refresh": refresh_token
      }
      axiosinstance
      .post(
        "token/refresh",
        parames,
        {
          headers: {
            "content-type": "application/json",
            "Authorization": localStorage.getItem("token")
          }
        }
      )
      .then(response => {
        localStorage.setItem(
          "token",
          "JWT " + response.data.access
        );
        localStorage.setItem(
          "refresh",
          response.data.refresh
        )
      })
    },
  }
}

export type CompanyStore = ReturnType<typeof companyStore>;